import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { TextBox } from 'srcReact/components/common2/TextBox'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import ToggleSwitch from 'srcReact/components/common2/ToggleSwitch'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'
import ImageCropper from 'srcReact/components/common2/ImageCropper'

import { profileActions } from '../../../../../../action'
import { settingsActions as sa } from '../../../../../../../Settings/action'
import styles from './styles.module.scss'
import Popup from 'reactjs-popup'
import PronounPopup from 'srcReact/components/popinsContent/PronounPopup'
import Avatar from 'srcReact/components/common2/Avatar'
import Spinner from 'srcReact/components/common2/Spinner'
import { commonActions } from 'srcReact/components'
import Modal from 'srcReact/components/common2/Modal'
import { urlSearchParams } from 'srcReact/helpers/utils'
import { loginActions } from 'srcReact/LoginPage'
import IconButton from 'srcReact/components/common2/IconButton'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { redirectToPage } from 'srcReact/helpers/history'
import useInterval from 'srcReact/helpers/hooks/useInterval'

export default function ProfilePopup({ setIsNestedModalOpen, decryptedImage, decryptedCoverImage, isNative }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    login: { user: loggedInUser },
    common: { isMobile, isTablet },
    myProfile: {
      profileData,
      putProfilePopupSuccess,
      putProfilePopupFailure,
      imageCropper,
      pictureUpdating,
      pictureUpdated,
      putProfilePicture
    },
    organization: {
      current_organization,
      header: { user_properties }
    }
  } = useSelector((state) => state)
  const { fileCreation } = useSelector((state) => state.common)
  const pronounPublic = profileData.user.is_display_pronoun === '1' ? true : false
  const numberPublic = profileData.user.is_display_phone === '1' ? true : false
  const emailPublic = profileData.user.is_display_email === '1' ? true : false
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [role, setRole] = useState('')
  const [selectedPronoun, setSelectedPronoun] = useState('')
  const [number, setNumber] = useState('')
  const [email, setEmail] = useState('')
  const [linkedIn, setLinkedIn] = useState(true)
  const [ig, setIg] = useState(true)
  const [imagePath, setImagePath] = useState('')
  const [coverImagePath, setCoverImagePath] = useState('')
  const [displayPronoun, setDisplayPronoun] = useState(pronounPublic)
  const [displayNumber, setDisplayNumber] = useState(numberPublic)
  const [displayEmail, setDisplayEmail] = useState(emailPublic)
  const [open, setOpen] = useState(false)
  const [newlyUploadedFile, setNewlyUploadedFile] = useState(null)
  const [showLoader, setShowLoader] = useState(false)
  const [pictureUploadStarted, setPictureUploadStarted] = useState(false)
  const [showDeletePicConfirmationModal, setShowDeletePicConfirmationModal] = useState(false)
  const [showDeleteCoverConfirmationModal, setShowDeleteCoverConfirmationModal] = useState(false)
  const [removePictureLoaderText, setRemovePictureLoaderText] = useState('')
  const [customPronounFirstPart, setCustomPronounFirstPart] = useState(
    profileData &&
      profileData.user &&
      profileData.user.personalized_pronoun &&
      profileData.user.personalized_pronoun.length > 0
      ? profileData.user.personalized_pronoun.split('/')[0]
      : ''
  )
  const [customPronounSecondPart, setCustomPronounSecondPart] = useState(
    profileData &&
      profileData.user &&
      profileData.user.personalized_pronoun &&
      profileData.user.personalized_pronoun.length > 0
      ? profileData.user.personalized_pronoun.split('/')[1]
      : ''
  )
  const [iOSPictureSizeError, setIOSPictureSizeError] = useState('')
  const [pronounOptions, setPronounOptions] = useState([
    { label: t('my_profile.pronoun.he_him'), value: 'he' },
    { label: t('my_profile.pronoun.she_her'), value: 'she' },
    { label: t('my_profile.pronoun.they_them'), value: 'they' },
    { label: t('my_profile.pronoun.other'), value: 'other' }
  ])

  useEffect(() => {
    if (pictureUploadStarted || pictureUpdating || fileCreation.loadingFile) {
      setShowLoader(true)
    } else {
      setShowLoader(false)
      setRemovePictureLoaderText('')
    }
  }, [pictureUploadStarted, pictureUpdating, fileCreation.loadingFile])

  const closeModal = () => {
    setOpen(false)
    setIsNestedModalOpen(false)
    setShowLoader(false)
    setRemovePictureLoaderText('')
  }
  const inputPicture = useRef(null)
  const inputCoverPicture = useRef(null)

  useEffect(() => {
    dispatch(profileActions.setInitial())
    setFirstName({ ...firstName, value: profileData.user.first_name })
    setLastName({ ...lastName, value: profileData.user.last_name })
    setRole({ ...role, value: profileData.user.current_occupation })
    setNumber({ ...number, value: profileData.user.phone_number })
    setEmail({ ...email, value: profileData.user.email })
    setLinkedIn({ ...linkedIn, value: profileData.user.linkedIn_url })
    setIg({ ...ig, value: profileData.user.instagram_url })
    // setExistingImageUrl(profileData.user.profile_picture)
    assignPronoun()
    if (putProfilePopupSuccess) {
      dispatch(loginActions.setName(profileData.user.first_name, profileData.user.last_name))
    }
  }, [profileData])

  const assignPronoun = () => {
    if (profileData.user.preferred_pronoun === 'he') {
      setSelectedPronoun({
        value: 'he',
        label: t('my_profile.pronoun.he_him')
      })
    } else if (profileData.user.preferred_pronoun === 'she') {
      setSelectedPronoun({
        value: 'she',
        label: t('my_profile.pronoun.she_her')
      })
    } else if (profileData.user.preferred_pronoun === 'they') {
      setSelectedPronoun({
        value: 'they',
        label: t('my_profile.pronoun.they_them')
      })
    } else if (profileData.user.preferred_pronoun === 'other') {
      setSelectedPronoun({
        value: 'other',
        label: `${t('my_profile.pronoun.other')} ${
          customPronounFirstPart && `(${customPronounFirstPart}/${customPronounSecondPart})`
        }`
      })
    } else if (profileData.user.preferred_pronoun === '' || profileData.user.preferred_pronoun === null) {
      setSelectedPronoun({
        value: '',
        label: t('my_profile.pronoun.pronoun')
      })
    }
  }

  const setOtherPronoun = () => {
    setSelectedPronoun({
      value: 'other',
      label: `${t('signup.success_step.pronoun.other')} ${
        customPronounFirstPart && `(${customPronounFirstPart} / ${customPronounSecondPart})`
      }`
    })
  }

  const handleFirstName = (e) => {
    setFirstName({
      ...firstName,
      value: e.target.value
    })
  }

  const handleLastName = (e) => {
    setLastName({
      ...lastName,
      value: e.target.value
    })
  }

  const handleRole = (e) => {
    setRole({
      ...role,
      value: e.target.value
    })
  }

  const handleLinkedIn = (e) => {
    setLinkedIn({
      ...linkedIn,
      value: e.target.value
    })
  }

  const handleIg = (e) => {
    setIg({
      ...ig,
      value: e.target.value
    })
  }

  const handleSelect = (pronoun) => {
    if (pronoun.value === 'other') {
      setOpen(true)
      setIsNestedModalOpen(true)
    } else {
      setSelectedPronoun({
        value: pronoun.value,
        label: pronoun.label
      })
    }
  }

  const handleToggle = (key, value) => {
    if (key === 'is_display_pronoun') {
      setDisplayPronoun(value)
    } else if (key === 'is_display_phone') {
      setDisplayNumber(value)
    } else if (key === 'is_display_email') {
      setDisplayEmail(value)
    }
  }

  const handleCancel = () => {
    dispatch(profileActions.setProfilePopup(false))
  }

  const handleSave = () => {
    dispatch(profileActions.setInitial())
    const pronounToggle = displayPronoun ? '1' : '0'
    const numberToggle = displayNumber ? '1' : '0'
    const emailToggle = displayEmail ? '1' : '0'
    const payload = {
      first_name: firstName.value === null ? '' : firstName.value,
      last_name: lastName.value === null ? '' : lastName.value,
      current_occupation: role.value === null ? '' : role.value,
      ...(selectedPronoun && selectedPronoun.value ? { preferred_pronoun: selectedPronoun.value } : {}),
      linkedIn_url: linkedIn.value === null ? '' : linkedIn.value,
      instagram_url: ig.value === null ? '' : ig.value,
      is_display_pronoun: pronounToggle === null ? '' : pronounToggle,
      is_display_phone: numberToggle === null ? '' : numberToggle,
      is_display_email: emailToggle === null ? '' : emailToggle,
      personalized_pronoun: customPronounFirstPart ? `${customPronounFirstPart}/${customPronounSecondPart}` : ''
    }
    const payload1 = {
      firstname: firstName.value === null ? '' : firstName.value,
      lastname: lastName.value === null ? '' : lastName.value
    }
    dispatch(profileActions.putProfilePopup(payload))
    dispatch(sa.putNames(payload1))
  }

  const handleClose = () => {
    dispatch(profileActions.setProfilePopup(false))
  }

  return (
    <div className={`${styles.profilePopup}`}>
      <div className={`${styles.titleWrap}`}>
        <h2 className={`${styles.title}`}>{t('my_profile.popup.information')}</h2>
        <button className={styles.closeWrap} onClick={handleClose}>
          <Icon name='close' styleModifier={styles.close} />
        </button>
      </div>
      <div className={`${styles.outerWrap}`}>
        <div className={`${styles.nameWrap}`}>
          <TextBox
            customWrapperCss={styles.inputWrap}
            customInputCss={styles.input}
            fieldInfo={firstName}
            onChange={handleFirstName}
            placeholder={t('my_profile.popup.first_name_pl')}
            disabled={!user_properties?.my_information_edition?.with_firstname}
          />
          <TextBox
            customWrapperCss={styles.inputWrap}
            customInputCss={styles.input}
            fieldInfo={lastName}
            onChange={handleLastName}
            placeholder={t('my_profile.popup.last_name_pl')}
            disabled={!user_properties?.my_information_edition?.with_lastname}
          />
        </div>
        <div className={`${styles.roleWrap}`}>
          <TextBox
            customWrapperCss={styles.inputWrap}
            customInputCss={styles.input}
            fieldInfo={role}
            onChange={handleRole}
            placeholder={t('my_profile.popup.role_pl')}
          />
          <Dropdown1
            value={selectedPronoun}
            onChange={handleSelect}
            options={pronounOptions}
            className={styles.dropdown}
            closeMenuOnSelect={true}
          />
          <div className={`${styles.toggleWrap}`}>
            <h2>{t('my_profile.popup.public')}</h2>
            <ToggleSwitch
              isChecked={displayPronoun}
              height={16}
              onChange={() => {
                handleToggle('is_display_pronoun', !displayPronoun)
              }}
            />
          </div>
        </div>
        <div className={`${styles.contactWrap}`}>
          <h2>{t('my_profile.popup.contact')}</h2>
          <div className={`${styles.outerWrap}`}>
            <div className={`${styles.iconOuterWrap}`}>
              <div className={`${styles.iconWrap}`}>
                <Icon name='phone' styleModifier={styles.icon} />
              </div>
              <TextBox
                customWrapperCss={styles.inputWrap}
                customInputCss={styles.input}
                fieldInfo={number}
                placeholder={t('my_profile.popup.phone_number_pl')}
                disabled
              />
            </div>
            <div className={`${styles.toggleWrap}`}>
              <h2>{t('my_profile.popup.public')}</h2>
              <ToggleSwitch
                isChecked={displayNumber}
                height={16}
                onChange={() => {
                  handleToggle('is_display_phone', !displayNumber)
                }}
              />
            </div>
          </div>
          <div className={`${styles.outerWrap}`}>
            <div className={`${styles.iconOuterWrap}`}>
              <div className={`${styles.iconWrap}`}>
                <Icon name='mail' styleModifier={styles.icon} />
              </div>
              <TextBox
                customWrapperCss={styles.inputWrap}
                customInputCss={styles.input}
                fieldInfo={email}
                placeholder={t('my_profile.popup.email_pl')}
                disabled
              />
            </div>
            <div className={`${styles.toggleWrap}`}>
              <h2>{t('my_profile.popup.public')}</h2>
              <ToggleSwitch
                isChecked={displayEmail}
                height={16}
                onChange={() => {
                  handleToggle('is_display_email', !displayEmail)
                }}
              />
            </div>
          </div>
        </div>
        <div className={`${styles.socialLinksWrap}`}>
          <h2>{t('my_profile.popup.social_links')}</h2>
          <div className={`${styles.outerWrap}`}>
            <div className={`${styles.socialWrap}`}>
              <img src={`${config.assetUrl}${'/images/linkedin-roundbtn.svg'}`} alt='linkedin' />
            </div>
            <TextBox
              customWrapperCss={styles.inputWrap}
              customInputCss={styles.input}
              fieldInfo={linkedIn}
              onChange={handleLinkedIn}
              placeholder={t('my_profile.popup.linkedin_url_pl')}
            />
          </div>
          <div className={`${styles.outerWrap}`}>
            <div className={`${styles.socialWrap}`}>
              <img src={`${config.assetUrl}${'/images/ig-roundbtn.svg'}`} alt='instagram' />
            </div>
            <TextBox
              customWrapperCss={styles.inputWrap}
              customInputCss={styles.input}
              fieldInfo={ig}
              onChange={handleIg}
              placeholder={t('my_profile.popup.instagram_url_pl')}
            />
          </div>
        </div>
        {putProfilePopupFailure && (
          <div>
            <h2 className={`${styles.errorMessage}`}>{putProfilePopupFailure}</h2>
          </div>
        )}
        <div className={`${styles.buttonWrap}`}>
          <Button
            text={t('global.cancel')}
            customStyle={styles.cancelButton}
            handleClick={handleCancel}
            size='medium'
          />
          <Button text={t('global.save')} handleClick={handleSave} size='medium' />
        </div>
      </div>
      <Popup
        contentStyle={{
          borderRadius: '1.3rem',
          width: 'fit-content'
        }}
        open={open}
        modal
        nested={true}
        closeOnDocumentClick={true}
        onClose={closeModal}>
        <PronounPopup
          closeModal={closeModal}
          customPronounFirst={customPronounFirstPart}
          customPronounSecond={customPronounSecondPart}
          setCustomPronounFirst={setCustomPronounFirstPart}
          setCustomPronounSecond={setCustomPronounSecondPart}
          setOtherPronoun={setOtherPronoun}
        />
      </Popup>
    </div>
  )
}
